import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_UTILITY_REQUEST_DETAILS,
  GET_UTILITY_REQUEST_DETAILS_SUCCESS,
  GET_UTILITY_REQUEST_DETAILS_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUtilityRequestDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/${payload.id}/details`,
      method: 'GET',
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      yield put({ type: GET_UTILITY_REQUEST_DETAILS_SUCCESS, payload: response?.data });
    } else {
      yield put({ type: GET_UTILITY_REQUEST_DETAILS_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_UTILITY_REQUEST_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetUtilityRequestDetails() {
  yield takeLatest(GET_UTILITY_REQUEST_DETAILS, getUtilityRequestDetails);
}

function* getUtilityRequestDetailsSaga() {
  yield all([fork(watchGetUtilityRequestDetails)]);
}

export default getUtilityRequestDetailsSaga;
